import moment from "moment";
import { setCurrentLanguage } from "../slices/currentLangSlice";
import { setCustomer } from "../slices/customerSlice";
import { setUser } from "../slices/userSlice";
import { store } from "../store";
const AuthProvider = () => {
    let authToken = null;
    let authExpirationStr = null;
    let authExpiration;
    let refreshToken = null;
    let refreshExpirationStr = null;
    let refreshExpiration;
    let permissions;
    let roles;
    const init = () => {
        let res = 0;
        const lang = localStorage.getItem("language");
        if (lang) {
            store.dispatch(setCurrentLanguage(lang));
        }
        if (authToken == null) {
            authToken = localStorage.getItem("authToken");
            authExpirationStr = localStorage.getItem("authExpiration");
            authExpiration =
                authExpirationStr != null
                    ? moment.utc(authExpirationStr, "YYYY-MM-DDThh:mm:ss")
                    : "";
            if (authToken == null) {
                res = 1;
            }
        }
        if (refreshToken == null) {
            refreshToken = localStorage.getItem("refreshToken");
            refreshExpirationStr = localStorage.getItem("refreshExpiration");
            refreshExpiration =
                refreshExpirationStr != null
                    ? moment.utc(refreshExpirationStr, "YYYY-MM-DDThh:mm:ss")
                    : "";
            if (refreshToken == null) {
                res = 2;
            }
        }
        if (moment.utc().isAfter(authExpiration)) {
            res = 1;
            localStorage.removeItem("authToken");
            localStorage.removeItem("authExpiration");
            authToken = null;
            authExpiration = "";
            authExpirationStr = null;
        }
        console.log("Pre refresh expired");
        console.log(moment.utc());
        console.log(refreshExpiration);
        if (moment.utc().isAfter(refreshExpiration)) {
            console.log("Refresh expired");
            res = 2;
            localStorage.removeItem("refreshToken");
            localStorage.removeItem("refreshExpiration");
            refreshToken = null;
            refreshExpiration = "";
            refreshExpirationStr = null;
        }
        if (res === 0 || res === 1) {
            const userStr = localStorage.getItem("user");
            if (userStr != null) {
                const user = JSON.parse(userStr);
                store.dispatch(setUser(user));
                roles = user.role;
            }
            const custStr = localStorage.getItem("customer");
            if (custStr != null) {
                const customer = JSON.parse(custStr);
                store.dispatch(setCustomer(customer));
            }
        }
        return res;
    };
    const getAuthToken = () => {
        if (moment.utc().isAfter(authExpiration) || authToken == null) {
            //window.location.href = '/login';
            return null;
        }
        return authToken;
    };
    const setAuthToken = (auth) => {
        if (auth.token != null && auth.expiration != null) {
            authToken = auth.token;
            authExpiration = moment.utc(auth.expiration, "DD.MM.YYYY hh:mm:ss");
            localStorage.setItem("authToken", auth.token);
            localStorage.setItem("authExpiration", auth.expiration);
        }
        else {
            authToken = null;
            authExpirationStr = null;
            localStorage.removeItem("authToken");
            localStorage.removeItem("authExpiration");
        }
    };
    const getRefreshToken = () => {
        if (moment.utc().isAfter(refreshExpiration))
            return null;
        return refreshToken;
    };
    const setRefreshToken = (refresh) => {
        if (refresh.token != null && refresh.expiration != null) {
            refreshToken = refresh.token;
            refreshExpiration = moment.utc(refresh.expiration, "DD.MM.YYYY hh:mm:ss");
            localStorage.setItem("refreshToken", refresh.token);
            localStorage.setItem("refreshExpiration", refresh.expiration);
        }
        else {
            refreshToken = null;
            refreshExpirationStr = null;
            localStorage.removeItem("refreshToken");
            localStorage.removeItem("refreshExpiration");
        }
    };
    const updateUser = (user) => {
        if (user) {
            roles = user.role;
            localStorage.setItem("user", JSON.stringify(user));
        }
        else {
            localStorage.removeItem("user");
        }
        store.dispatch(setUser(user));
    };
    const updateLanguage = (lang) => {
        localStorage.setItem("language", lang);
    };
    const getRoles = () => {
        return roles !== null && roles !== void 0 ? roles : [];
    };
    const logout = () => {
        localStorage.removeItem("user");
        localStorage.removeItem("authToken");
        localStorage.removeItem("authExpiration");
        localStorage.removeItem("refreshToken");
        localStorage.removeItem("refreshExpiration");
    };
    return {
        init,
        updateLanguage,
        getAuthToken,
        setAuthToken,
        getRefreshToken,
        setRefreshToken,
        updateUser,
        getRoles,
        logout,
    };
};
export default AuthProvider();
